module.exports = __webpack_public_path__ + "static/media/outdent.56ef92e4.svg";